import React from 'react';
import { Box, Typography } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import {
  HOTEL_NEARBY_LOCATION_LABEL,
  HOTEL_NEARBY_LOCATION_LOADING,
  HOTEL_NEARBY_LOCATION_SUBTITLE,
} from '../../../constants/hotelSearch.constants';
import {
  createGtmAttributes,
  GTM_CLICK_IDS,
  GTM_CONTEXT_ATTRS,
} from '../../../analytics/gtmClickIds';
import { resolveHotelNearbyLocation } from '../../../utils/hotelNearbyLocation';
import { getCurrentCoordinates } from '../../../utils/geolocation';

class HotelNearbyLocationOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleClick = async () => {
    if (this.state.loading) return;

    this.setState({ loading: true });
    const coordinatesPromise = getCurrentCoordinates();

    try {
      const coordinates = await coordinatesPromise;
      const location = await resolveHotelNearbyLocation({
        getCoordinates: async () => coordinates,
      });
      this.props.onSelect?.(location);
    } catch (error) {
      this.props.onError?.(error.message);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  };

  render() {
    const { variant = 'desktop', gtmContext = 'home' } = this.props;
    const { loading } = this.state;
    const isMobile = variant === 'mobile';

    return (
      <Box
        role="button"
        tabIndex={0}
        aria-label={HOTEL_NEARBY_LOCATION_LABEL}
        className={isMobile ? 'mobile-sheet-option hotel-nearby-location-option' : 'hotel-location-option hotel-nearby-location-option'}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        {...createGtmAttributes(GTM_CLICK_IDS.HOTEL_SEARCH_NEARBY_LOCATION, {
          [GTM_CONTEXT_ATTRS.CONTEXT]: gtmContext,
        })}
      >
        <Box
          sx={{
            width: '18px',
            height: '18px',
            mr: '12px',
            flexShrink: 0,
            mt: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MyLocationIcon sx={{ fontSize: '16px', color: '#5E35B1' }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            className={isMobile ? 'flight-dropdown-option-city' : undefined}
            sx={isMobile ? { fontSize: '15px !important' } : {
              fontWeight: 600,
              color: '#20202A',
              fontSize: '14px',
              marginBottom: '2px',
            }}
          >
            {loading ? HOTEL_NEARBY_LOCATION_LOADING : HOTEL_NEARBY_LOCATION_LABEL}
          </Typography>
          <Typography
            className={isMobile ? 'flight-dropdown-option-airport' : undefined}
            sx={isMobile ? undefined : {
              fontSize: '12px',
              color: '#7E808F',
            }}
          >
            {HOTEL_NEARBY_LOCATION_SUBTITLE}
          </Typography>
        </Box>
      </Box>
    );
  }
}

export default HotelNearbyLocationOption;
